import { render, staticRenderFns } from "./CbxBenefitType.vue?vue&type=template&id=903302cc&"
import script from "./CbxBenefitType.vue?vue&type=script&lang=ts&"
export * from "./CbxBenefitType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports